import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbSection, AbContainer, AbLink, AbIcon } from '../../ui';
import { Spacing, DEFAULT_SPACING } from '../../../helpers/shared-props';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  id?: string;
  top?: {
    title?: string;
    files?: {
      url?: string;
      filename?: string;
      name?: string;
    }[];
  };
  bottom?: {
    title?: string;
    text?: string;
    downloadButton?: {
      link?: string;
      target?: string;
      download?: string;
      text?: string;
      version?: string;
    };
    icons?: string[];
  };
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentSectionSimple',
  props: {
    id: null,
    top: null,
    bottom: null,
    spacing: { default: () => DEFAULT_SPACING }
  },
  setup(__props: any) {



return { __sfc: true,AbTitle, AbSection, AbContainer, AbLink, AbIcon, CdnImg }
}

})